import { MissionData } from '../blocks/mission'
import template from './templates/RJF05.rbxl'
import thumbnail1 from './thumbnails/RJF05/BlueBlock.png'
import thumbnail2 from './thumbnails/RJF05/RedBlock.png'
import thumbnail3 from './thumbnails/RJF05/Mato.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}],
  objects: [
    {
      name: '①あおいブロック',
      thumbnail: thumbnail1,
    },
    {
      name: '②あかいブロック',
      thumbnail: thumbnail2,
    },
    {
      name: '③マト',
      thumbnail: thumbnail3,
    },
  ],
}

export default mission
